import loadable from '@loadable/component';

// Lazy-loaded: Turnstile requires browser environment
export const TurnstileField = loadable(
  () => import(/* webpackChunkName: "TurnstileField" */ './TurnstileField'),
  { ssr: false }
);

export { default as translations } from './translations.json';
